export const FinalStep = ({}) => {
    return (
        <>

            <div id={"final-step"}>
                <img src={"images/complete.jpg"} alt={"success"}/>
                <h2>Užsakymas sėkmingai pateiktas!</h2>
                <p>Jūsų užsakymas buvo sėkmingai pateiktas. Mūsų komanda susisieks su jumis, kad patvirtintų užsakymo
                    detales.</p>

                <button onClick={() => window.location.reload()} className={"btn primary-btn"}>Pateikti naują užsakymą
                </button>
            </div>
        </>
    );
}
